import type { PointDto } from "common/models/api/models/PointDto";
import { Queries } from "ui/query/queries";
import type { QueryResult } from "ui/query/react-query-overrides";
import { useQuery } from "react-query";
import { pointsApi } from "features/points/api/pointsApi";

export interface UseGetPaymentGatewayPointParams {
    tokenAddress?: string;
}

export default function useGetPaymentGatewayPoint({ tokenAddress }: UseGetPaymentGatewayPointParams): QueryResult<PointDto> {
    const safeTokenAddress = tokenAddress as string;

    return useQuery(
        [Queries.PAYMENT_GATEWAY_POINT, tokenAddress],
        async () => {
            const res = await pointsApi.findByTokenAddress(safeTokenAddress);
            return res.data;
        },
        { enabled: Boolean(tokenAddress) },
    );
}
